export const CLOSED_LIVE_SESSION_BANNER = 'closed';
